import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { GinoFitScoreData } from "../types/candidate";
import { GapItemIcon, StrengthItemIcon } from "../assets/icons/go-hire-page-icons";

const GinoCandidateSummary = ({ ginoFitScoreData }: { ginoFitScoreData: GinoFitScoreData }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.ginoCandidateSummary" });

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("summary")}</Typography>
      <Box component="data" sx={styles.sectionInfo}>
        <Typography component="label" sx={styles.sectionLabel}>
          {t("executiveSummary")}
        </Typography>
        <Typography sx={styles.sectionInfoValue}>{ginoFitScoreData.summary}</Typography>
      </Box>
      <List listTitle={t("keyStrengths")} listIcon={<StrengthItemIcon />} listItems={ginoFitScoreData.strengths} />
      <List listTitle={t("areasForImprovement")} listIcon={<GapItemIcon />} listItems={ginoFitScoreData.gaps} />
      <Box component="data" sx={styles.sectionInfo}>
        <Typography component="label" sx={styles.sectionLabel}>
          {t("recommendation")}
        </Typography>
        <Typography sx={styles.sectionInfoValue}>{ginoFitScoreData.recommendation}</Typography>
      </Box>
    </Box>
  );
};

export default GinoCandidateSummary;

const List = ({
  listTitle,
  listIcon,
  listItems,
}: {
  listTitle: string;
  listIcon: React.ReactNode;
  listItems: string[];
}) => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.ginoCandidateSummary" });

  return (
    <Box component="data" sx={styles.sectionInfo}>
      <Typography component="label" sx={styles.sectionLabel}>
        {listTitle}
      </Typography>
      <Box component="ul" sx={styles.sectionInfoList}>
        {listItems.length === 0 && <Typography sx={styles.sectionInfoValue}>{t("noGaps")}</Typography>}
        {listItems.map((item) => (
          <Box component="li" sx={styles.sectionInfoListItem}>
            {listIcon}
            <Typography sx={styles.sectionInfoValue}>{item}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "24px",
    borderRadius: "12px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
  },
  title: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  sectionLabel: {
    fontFamily: "Montserrat",
    color: "var(--black, #141414)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  sectionInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    p: 0,
  },
  sectionInfoValue: {
    fontFamily: "Montserrat",
    color: "var(--Gray-600, #475467)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
  sectionInfoList: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    flexWrap: "wrap",
    gap: "8px",
  },
  sectionInfoListItem: {
    width: { xs: "100%", sm: "calc(50% - 4px)" },
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};
